<template>
  <div class="paymentMethodsTable">
    <SimpleTable
      :data="table"
      class="deliveryTable__table"
      :variants="['smallHeadings', 'borderInside']"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable';
export default {
  name: 'PaymentMethodsTable',
  components: { SimpleTable },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      table: {
        headings: {},
        content: {},
      },
    };
  },
  mounted() {
    if (this.data.Headings && this.data.Content) {
      this.table = {
        headings: this.data.Headings.map(heading => heading.Heading),
        content: this.data.Content.map(content => content.map(item => item.ColumnContent)),
      };
    }
  },
};
</script>

<style scoped lang="scss">
.paymentMethodsTable {
  padding: 3rem;
  background-color: $cWhite;

  @include rwd('large-phone') {
    padding: 2rem;
  }
}
</style>
